<ng-container>
  <!--    <div>CustomPreviewEntityModule Content</div>-->
  @if (template) {
    <div
    [innerHtml]="template | replaceTokensArray: {keys: item} | safe: 'html'"></div>
  }
</ng-container>
